import { useState, useEffect } from "react";
import { Box, Typography, TextField, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const EditableOHQ = ({ value, onChange }) => {
    const [isNok, setIsNok] = useState(false);
    const [ohq, setOhq] = useState(value ?? "");
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        setOhq(value ?? "");
    }, [value]);

    const handleOkay = () => {
        onChange(value);
        setIsSubmitted(true);
    };

    const handleNok = () => {
        setIsNok(true);
        setOhq(value ?? "");
    };

    const handleCancel = () => {
        setOhq(value ?? "");
        setIsNok(false);
    };

    const handleSaveNok = () => {
        if (
            ohq === "" ||
            !Number.isFinite(Number(ohq)) ||
            Number(ohq) < 0
        ) {
            return;
        }

        onChange(Number(ohq));
        setIsSubmitted(true);
        setIsNok(false);
    };

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
            py={1}
        >
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ minWidth: 35 }}
            >
                Physical QTY
            </Typography>

            <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={1}
                flex={1}
            >
                {!isSubmitted && !isNok && (
                    <Button
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={handleOkay}
                    >
                        Okay
                    </Button>
                )}

                <TextField
                    type="number"
                    size="small"
                    value={ohq}
                    disabled={!isNok || isSubmitted}
                    onChange={(e) => setOhq(e.target.value)}
                    inputProps={{ min: 0, step: "any" }}
                    sx={{ width: 110 }}
                />

                {isNok && !isSubmitted ? (
                    <>
                        <IconButton
                            size="small"
                            color="success"
                            onClick={handleSaveNok}
                            aria-label="Save updated OHQ"
                        >
                            <CheckIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                            size="small"
                            onClick={handleCancel}
                            aria-label="Cancel NOK"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </>
                ) : (
                    !isSubmitted && (
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={handleNok}
                        >
                            NOK
                        </Button>
                    )
                )}
            </Box>
        </Box>
    );
};

export default EditableOHQ;